import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Chip from '@material-ui/core/Chip';

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        fileType: file.type,
        imagePreviewUrl: reader.result
      });
      // revisar si es mejor pasar el onChange dentro del onloaden
      this.props.onChangeFile(file)
    };
    reader.readAsDataURL(file);

  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    this.setState({
      file: null,
      fileType: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
    });
    if(this.props.onChangeFile)
      this.props.onChangeFile(null)
    this.refs.fileInput.value = null;
  }
  render() {
    var {
      avatar,
      addButtonProps,
      changeButtonProps,
      removeButtonProps
    } = this.props;
    const { file, fileType } = this.state;
    return (
      <div className="fileinput text-center">
        <input type="file" accept="application/pdf" onChange={this.handleImageChange} ref="fileInput" />
        { file && fileType === 'application/pdf' && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
            <h5>Se ha adjuntado el archivo: <b>"{file.name}"</b></h5>
          </div>
        )}

        {file && fileType !== 'application/pdf' && (
          <i
            style={{
              fontWeight: 'bold',
              color: '#dc3545'
            }}
          >
            Debes adjuntar un archivo en formato PDF.
          </i>
        )}

        <div>
          {file === null ? (
            <Button {...addButtonProps} onClick={() => this.handleClick()}>
              {avatar ? "Add Photo" : this.props.title}
            </Button>
          ) : (
            <span>
              <Button {...changeButtonProps} onClick={() => this.handleClick()}>
                Modificar
              </Button>
              {avatar ? <br /> : null}
              <Button
                {...removeButtonProps}
                onClick={() => this.handleRemove()}
              >
                <i className="fas fa-times" /> Remover
              </Button>
            </span>
          )}
        </div>
      </div>
    );
  }
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ImageUpload.jsx
